// Extracted from layout/theme.liquid so it is cached across pageviews.
(function initBwShippingBar() {
        const scriptData = document.currentScript?.dataset || {};
        const barSelector = '[data-bw-shipping-bar]';
        const drawerContentSelector = '.cart-drawer__content';
        const drawerItemsSelector = '.cart-drawer__items';
        const styleId = 'bw-shipping-bar-runtime-styles';
        const rewardProgressSetting = scriptData.rewardProgress === 'false' ? false : true;
        const rewardProgressEnabled = rewardProgressSetting !== false;
        const rewardThresholdCents = Number(scriptData.rewardThreshold) || 16999;
        const freeShippingThresholdCents = 6999;
        let observerStarted = false;
        let refreshScheduled = false;
        let scheduledCart = null;
        let refreshInFlight = null;
        let lastKnownCart = null;
        let refreshVersion = 0;
        let appliedVersion = 0;
        let followUpRefreshTimerIds = [];

        function getBars() {
          return Array.from(document.querySelectorAll(barSelector));
        }

        function hasShippingBarContext() {
          return Boolean(document.querySelector(barSelector) || document.querySelector(drawerContentSelector));
        }

        function normalizeCurrencyCode(currency) {
          return String(currency || '').trim().toUpperCase();
        }

        function getShopifyCartMoneyFactor() {
          // Ajax cart monetary fields use a cents-style multiplier even for zero-decimal currencies.
          return 100;
        }

        function getCartCurrency(cart) {
          return normalizeCurrencyCode(cart?.currency || window.Shopify?.currency?.active || 'USD') || 'USD';
        }

        function getActiveCurrencyRate(currency) {
          const normalized = normalizeCurrencyCode(currency);
          if (!normalized || normalized === 'USD') return 1;

          const shopifyCurrency = window.Shopify?.currency || {};
          const activeCurrency = normalizeCurrencyCode(shopifyCurrency.active);
          const rate = Number(shopifyCurrency.rate || 0);

          if (activeCurrency === normalized && Number.isFinite(rate) && rate > 0) return rate;
          return 0;
        }

        function getRewardThresholdForCart(cart) {
          const currency = getCartCurrency(cart);
          if (currency === 'USD') return rewardThresholdCents;

          const rate = getActiveCurrencyRate(currency);
          if (!rate) return Number.POSITIVE_INFINITY;

          const convertedThreshold = rewardThresholdCents * rate;
          return currency === 'JPY'
            ? Math.ceil(convertedThreshold / 10000) * 10000
            : Math.ceil(convertedThreshold);
        }

        function getFreeShippingThresholdForCart(cart) {
          const currency = getCartCurrency(cart);
          if (currency === 'USD') return freeShippingThresholdCents;

          const rate = getActiveCurrencyRate(currency);
          if (!rate) return Number.POSITIVE_INFINITY;

          const convertedThreshold = freeShippingThresholdCents * rate;
          return currency === 'JPY'
            ? Math.ceil(convertedThreshold / 10000) * 10000
            : Math.ceil(convertedThreshold);
        }

        const shippingBarTranslations = {
          en: {
            freeShippingMilestone: '🎉 $69.99 free shipping',
            giftMilestone: '🎁 $169.99 small gift',
            giftUnlocked: '🎁 Free shipping & $19.99+ gift unlocked',
            giftProgressBefore: '🎉 Free shipping · Add ',
            giftProgressAfter: ' for a $19.99+ gift',
            freeUnlocked: '🎉 Free shipping unlocked',
            freeProgressBefore: 'Add ',
            freeProgressAfter: ' for free shipping',
          },
          ja: {
            freeShippingMilestone: '🎉 11,200円以上で送料無料',
            giftMilestone: '🎁 27,000円以上で小さなギフト',
            giftUnlocked: '🎉 送料無料 · 🎁 ギフト獲得',
            giftProgressBefore: '🎉 送料無料 · 🎁 あと',
            giftProgressAfter: 'でギフト獲得',
            freeUnlocked: '🎉 送料無料になりました',
            freeProgressBefore: 'あと',
            freeProgressAfter: 'で送料無料',
          },
          fr: {
            freeShippingMilestone: '🎉 Livraison gratuite dès 69,99 $US',
            giftMilestone: '🎁 Petit cadeau dès 169,99 $US',
            giftUnlocked: '🎉 Livraison gratuite · 🎁 Cadeau débloqué',
            giftProgressBefore: '🎉 Livraison gratuite · 🎁 Plus que ',
            giftProgressAfter: ' pour le cadeau',
            freeUnlocked: '🎉 Livraison gratuite débloquée',
            freeProgressBefore: 'Ajoutez ',
            freeProgressAfter: ' pour la livraison gratuite',
          },
          de: {
            freeShippingMilestone: '🎉 Kostenloser Versand ab 69,99 US$',
            giftMilestone: '🎁 Kleines Geschenk ab 169,99 US$',
            giftUnlocked: '🎉 Kostenloser Versand · 🎁 Geschenk freigeschaltet',
            giftProgressBefore: '🎉 Kostenloser Versand · 🎁 Noch ',
            giftProgressAfter: ' bis zum Geschenk',
            freeUnlocked: '🎉 Kostenloser Versand freigeschaltet',
            freeProgressBefore: 'Noch ',
            freeProgressAfter: ' bis zum kostenlosen Versand',
          },
          es: {
            freeShippingMilestone: '🎉 Envío gratis desde 69,99 US$',
            giftMilestone: '🎁 Pequeño regalo desde 169,99 US$',
            giftUnlocked: '🎉 Envío gratis · 🎁 Regalo desbloqueado',
            giftProgressBefore: '🎉 Envío gratis · 🎁 Faltan ',
            giftProgressAfter: ' para el regalo',
            freeUnlocked: '🎉 Envío gratis desbloqueado',
            freeProgressBefore: 'Añade ',
            freeProgressAfter: ' para envío gratis',
          },
          it: {
            freeShippingMilestone: '🎉 Spedizione gratuita da 69,99 US$',
            giftMilestone: '🎁 Piccolo regalo da 169,99 US$',
            giftUnlocked: '🎉 Spedizione gratuita · 🎁 Regalo sbloccato',
            giftProgressBefore: '🎉 Spedizione gratuita · 🎁 Mancano ',
            giftProgressAfter: ' al regalo',
            freeUnlocked: '🎉 Spedizione gratuita sbloccata',
            freeProgressBefore: 'Aggiungi ',
            freeProgressAfter: ' per la spedizione gratuita',
          },
          nl: {
            freeShippingMilestone: '🎉 Gratis verzending vanaf US$69,99',
            giftMilestone: '🎁 Klein cadeau vanaf US$169,99',
            giftUnlocked: '🎉 Gratis verzending · 🎁 Cadeau ontgrendeld',
            giftProgressBefore: '🎉 Gratis verzending · 🎁 Nog ',
            giftProgressAfter: ' tot cadeau',
            freeUnlocked: '🎉 Gratis verzending ontgrendeld',
            freeProgressBefore: 'Voeg ',
            freeProgressAfter: ' toe voor gratis verzending',
          },
          pt: {
            freeShippingMilestone: '🎉 Frete grátis a partir de US$69,99',
            giftMilestone: '🎁 Pequeno presente a partir de US$169,99',
            giftUnlocked: '🎉 Frete grátis · 🎁 Presente desbloqueado',
            giftProgressBefore: '🎉 Frete grátis · 🎁 Faltam ',
            giftProgressAfter: ' para o presente',
            freeUnlocked: '🎉 Frete grátis desbloqueado',
            freeProgressBefore: 'Adicione ',
            freeProgressAfter: ' para frete grátis',
          },
          zh: {
            freeShippingMilestone: '🎉 满 US$69.99 包邮',
            giftMilestone: '🎁 满 US$169.99 送小礼物',
            giftUnlocked: '🎉 已包邮 · 🎁 已解锁赠品',
            giftProgressBefore: '🎉 已包邮 · 🎁 还差',
            giftProgressAfter: '解锁赠品',
            freeUnlocked: '🎉 已解锁包邮',
            freeProgressBefore: '还差',
            freeProgressAfter: '包邮',
          },
          'zh-tw': {
            freeShippingMilestone: '🎉 滿 US$69.99 免運',
            giftMilestone: '🎁 滿 US$169.99 送小禮物',
            giftUnlocked: '🎉 已免運 · 🎁 已解鎖贈品',
            giftProgressBefore: '🎉 已免運 · 🎁 還差',
            giftProgressAfter: '解鎖贈品',
            freeUnlocked: '🎉 已解鎖免運',
            freeProgressBefore: '還差',
            freeProgressAfter: '免運',
          },
          ko: {
            freeShippingMilestone: '🎉 US$69.99 이상 무료 배송',
            giftMilestone: '🎁 US$169.99 이상 작은 선물',
            giftUnlocked: '🎉 무료 배송 · 🎁 선물 잠금 해제',
            giftProgressBefore: '🎉 무료 배송 · 🎁 ',
            giftProgressAfter: ' 더 담으면 선물',
            freeUnlocked: '🎉 무료 배송 잠금 해제',
            freeProgressBefore: '',
            freeProgressAfter: ' 더 담으면 무료 배송',
          },
        };

        function normalizeLanguageCode(value) {
          return String(value || '').trim().toLowerCase().replace('_', '-');
        }

        function getShippingBarLanguage() {
          const pathLocale = normalizeLanguageCode(window.location.pathname.split('/').filter(Boolean)[0]);
          const candidates = [
            normalizeLanguageCode(window.Shopify?.locale),
            normalizeLanguageCode(document.documentElement.lang),
            pathLocale,
          ].filter(Boolean);

          for (const candidate of candidates) {
            if (shippingBarTranslations[candidate]) return candidate;
            if (candidate.startsWith('zh-hant') || candidate === 'zh-tw' || candidate === 'zh-hk') return 'zh-tw';
            const base = candidate.split('-')[0];
            if (shippingBarTranslations[base]) return base;
          }

          return 'en';
        }

        function getShippingBarCopy() {
          return shippingBarTranslations[getShippingBarLanguage()] || shippingBarTranslations.en;
        }

        function escapeHtml(value) {
          return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
        }

        function renderAmountMessage(before, amount, after) {
          return before + '<span class="bw-sb-amount">' + escapeHtml(amount) + '</span>' + after;
        }

        function applyLocalizedMilestones(bar, cart) {
          const copy = getShippingBarCopy();
          const freeMilestone = bar.querySelector('[data-bw-free-shipping-milestone]');
          const giftMilestone = bar.querySelector('[data-bw-gift-milestone]');
          if (getShippingBarLanguage() === 'ja' && isCartPayload(cart)) {
            const localizedFreeThreshold = getFreeShippingThresholdForCart(cart);
            const localizedGiftThreshold = getRewardThresholdForCart(cart);
            if (freeMilestone instanceof HTMLElement) {
              freeMilestone.textContent = Number.isFinite(localizedFreeThreshold)
                ? '🎉 ' + formatMoney(localizedFreeThreshold, cart, bar) + '以上で送料無料'
                : copy.freeShippingMilestone;
            }
            if (giftMilestone instanceof HTMLElement) {
              giftMilestone.textContent = Number.isFinite(localizedGiftThreshold)
                ? '🎁 ' + formatMoney(localizedGiftThreshold, cart, bar) + '以上で小さなギフト'
                : copy.giftMilestone;
            }
            return;
          }
          if (freeMilestone instanceof HTMLElement) freeMilestone.textContent = copy.freeShippingMilestone;
          if (giftMilestone instanceof HTMLElement) giftMilestone.textContent = copy.giftMilestone;
        }

        function isCartPayload(cart) {
          return Boolean(
            cart &&
              typeof cart === 'object' &&
              Array.isArray(cart.items) &&
              typeof cart.total_price !== 'undefined'
          );
        }

        function extractCartFromEvent(event) {
          const detail = event?.detail;
          const candidates = [
            detail?.cart,
            detail?.resource,
            detail?.data?.cart,
            detail?.data?.resource,
            detail?.data,
          ];

          return candidates.find(isCartPayload) || null;
        }

        function nextRefreshVersion() {
          refreshVersion += 1;
          return refreshVersion;
        }

        function ensureStyles() {
          if (document.getElementById(styleId)) return;

          const style = document.createElement('style');
          style.id = styleId;
          style.textContent = [
            '.bw-shipping-bar-wrapper {',
            '  padding: 15px 20px;',
            '  background: #fff;',
            '  border-bottom: 1px solid #eee;',
            '  width: 100%;',
            '  box-sizing: border-box;',
            '  display: block;',
            '}',
            '.bw-sb-text {',
            '  text-align: center;',
            '  font-size: 14px;',
            '  margin-bottom: 8px;',
            '  color: #333;',
            '  font-weight: 600;',
            '  line-height: 1.35;',
            '}',
            '.bw-sb-track {',
            '  height: 10px;',
            '  background-color: #f2f2f2;',
            '  border-radius: 10px;',
            '  overflow: hidden;',
            '  position: relative;',
            '  width: 100%;',
            '}',
            '.bw-sb-fill {',
            '  height: 100%;',
            '  border-radius: 10px;',
            '  transition: width 0.22s ease, background-color 0.22s ease;',
            '  width: 0%;',
            '  background-color: #8a75d5;',
            '  background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);',
            '  background-size: 1rem 1rem;',
            '  animation: bw-progress-bar-stripes 1s linear infinite;',
            '}',
            '.bw-sb-fill.is-success {',
            '  background-color: #4CAF50 !important;',
            '}',
            '.bw-sb-fill.is-gift-progress {',
            '  background-color: #5f7a61 !important;',
            '}',
            '.bw-sb-fill.is-gift-unlocked {',
            '  background-color: #ff4b1f !important;',
            '}',
            '.bw-sb-amount {',
            '  color: #ff4b1f;',
            '  font-weight: 800;',
            '}',
            '.bw-sb-milestones {',
            '  display: flex;',
            '  justify-content: space-between;',
            '  gap: 8px;',
            '  margin-top: 7px;',
            '  color: #8b947f;',
            '  font-size: 10.5px;',
            '  font-weight: 700;',
            '  line-height: 1.2;',
            '}',
            '.bw-sb-milestone.is-unlocked {',
            '  color: #4CAF50;',
            '}',
            '[data-bw-gift-milestone].is-unlocked {',
            '  color: #ff4b1f;',
            '}',
            '@keyframes bw-progress-bar-stripes {',
            '  0% { background-position: 1rem 0; }',
            '  100% { background-position: 0 0; }',
            '}',
          ].join('\n');

          document.head.appendChild(style);
        }

        function createBarElement(currencySymbol) {
          const bar = document.createElement('div');
          bar.className = 'bw-shipping-bar-wrapper';
          bar.id = 'bw-shipping-bar';
          bar.dataset.bwShippingBar = '';
          bar.dataset.threshold = String(freeShippingThresholdCents / 100);
          bar.dataset.rewardThreshold = String(rewardThresholdCents / 100);
          bar.dataset.rewardProgressEnabled = rewardProgressEnabled ? 'true' : 'false';
          bar.dataset.currencySymbol = currencySymbol || '$';
          const copy = getShippingBarCopy();
          bar.innerHTML = [
            '<div class="bw-sb-text" id="bw-sb-message" data-bw-shipping-message></div>',
            '<div class="bw-sb-track">',
            '  <div class="bw-sb-fill" id="bw-sb-fill" data-bw-shipping-fill></div>',
            '</div>',
            '<div class="bw-sb-milestones" aria-hidden="true">',
            '  <span class="bw-sb-milestone" data-bw-free-shipping-milestone>' + copy.freeShippingMilestone + '</span>',
            '  <span class="bw-sb-milestone" data-bw-gift-milestone>' + copy.giftMilestone + '</span>',
            '</div>',
          ].join('');
          return bar;
        }

        function removeDrawerBars() {
          document.querySelectorAll('[data-bw-shipping-slot]').forEach(function (slot) {
            slot.remove();
          });
          getBars().forEach(function (bar) {
            bar.remove();
          });
        }

        function ensureDrawerBar(cart) {
          const drawerContent = document.querySelector(drawerContentSelector);
          if (!(drawerContent instanceof HTMLElement)) return null;

          if (Number(cart?.item_count || 0) === 0) {
            removeDrawerBars();
            return null;
          }

          ensureStyles();

          const existingBar = drawerContent.querySelector(barSelector);
          if (existingBar instanceof HTMLElement) {
            if (cart?.currency) existingBar.dataset.currencySymbol = cart.currency;
            existingBar.dataset.threshold = String(freeShippingThresholdCents / 100);
            existingBar.dataset.rewardThreshold = String(rewardThresholdCents / 100);
            existingBar.dataset.rewardProgressEnabled = rewardProgressEnabled ? 'true' : 'false';
            return existingBar;
          }

          const slot = document.createElement('div');
          slot.className = 'bw-shipping-bar-slot';
          slot.dataset.bwShippingSlot = '';

          const bar = createBarElement(cart?.currency);
          slot.appendChild(bar);

          const itemsContainer = drawerContent.querySelector(drawerItemsSelector);
          if (itemsContainer instanceof HTMLElement) {
            drawerContent.insertBefore(slot, itemsContainer);
          } else {
            drawerContent.prepend(slot);
          }

          return bar;
        }

        function getProgressState(cart, bar) {
          const freeShippingThreshold = getFreeShippingThresholdForCart(cart);
          const rewardThresholdForCart = getRewardThresholdForCart(cart);
          const giftProgressEnabled = bar.dataset.rewardProgressEnabled !== 'false' && Number.isFinite(rewardThresholdForCart);
          const rewardThreshold = giftProgressEnabled ? Math.max(rewardThresholdForCart, freeShippingThreshold) : freeShippingThreshold;
          const total = Number(cart?.total_price || 0);
          const progressThreshold = giftProgressEnabled ? rewardThreshold : freeShippingThreshold;
          const percent = Math.min((total / progressThreshold) * 100, 100);
          const freeUnlocked = total >= freeShippingThreshold;
          const giftUnlocked = giftProgressEnabled && total >= rewardThreshold;

          return {
            freeShippingThreshold,
            rewardThreshold,
            giftProgressEnabled,
            total,
            percent,
            freeUnlocked,
            giftUnlocked,
          };
        }

        function formatMoney(cents, cart, bar) {
          const currency = getCartCurrency(cart);
          const amount = Number(cents || 0) / getShopifyCartMoneyFactor();
          try {
            const displayLocale = getShippingBarLanguage() === 'ja' ? 'ja-JP' : undefined;
            return new Intl.NumberFormat(displayLocale, {
              style: 'currency',
              currency,
              currencyDisplay: 'narrowSymbol',
            }).format(amount);
          } catch (error) {
            const symbol = bar.dataset.currencySymbol && bar.dataset.currencySymbol.length <= 2 ? bar.dataset.currencySymbol : '$';
            return symbol + amount.toFixed(2);
          }
        }

        function updateBar(bar, cart) {
          if (!(bar instanceof HTMLElement) || !isCartPayload(cart)) return;

          const message = bar.querySelector('[data-bw-shipping-message]');
          const fill = bar.querySelector('[data-bw-shipping-fill]');
          const freeMilestone = bar.querySelector('[data-bw-free-shipping-milestone]');
          const giftMilestone = bar.querySelector('[data-bw-gift-milestone]');

          if (!(message instanceof HTMLElement) || !(fill instanceof HTMLElement)) return;

          if (cart?.currency) bar.dataset.currencySymbol = cart.currency;
          applyLocalizedMilestones(bar, cart);

          const state = getProgressState(cart, bar);
          const freeUnlocked = state.freeUnlocked;
          const giftUnlocked = state.giftUnlocked;
          const percent = state.percent;

          fill.style.width = percent.toFixed(2).replace(/\.00$/, '') + '%';
          fill.style.backgroundColor = giftUnlocked ? '#ff4b1f' : freeUnlocked ? '#4CAF50' : '';
          bar.dataset.bwRewardStage = giftUnlocked ? 'gift' : freeUnlocked ? 'free-shipping' : 'locked';
          bar.dataset.bwCartTotalCents = String(state.total);
          fill.classList.remove('is-gift-progress');
          fill.classList.toggle('is-success', freeUnlocked && !giftUnlocked);
          fill.classList.toggle('is-gift-unlocked', giftUnlocked);

          if (freeMilestone instanceof HTMLElement) freeMilestone.classList.toggle('is-unlocked', freeUnlocked);
          if (giftMilestone instanceof HTMLElement) giftMilestone.classList.toggle('is-unlocked', giftUnlocked);

          if (giftUnlocked) {
            message.innerHTML = getShippingBarCopy().giftUnlocked;
            return;
          }

          if (freeUnlocked && state.giftProgressEnabled) {
            const remainingGift = Math.max(state.rewardThreshold - state.total, 0);
            const copy = getShippingBarCopy();
            message.innerHTML = renderAmountMessage(copy.giftProgressBefore, formatMoney(remainingGift, cart, bar), copy.giftProgressAfter);
            return;
          }

          if (freeUnlocked) {
            message.innerHTML = getShippingBarCopy().freeUnlocked;
            return;
          }

          const remaining = Math.max(state.freeShippingThreshold - state.total, 0);
          const copy = getShippingBarCopy();
          message.innerHTML = renderAmountMessage(copy.freeProgressBefore, formatMoney(remaining, cart, bar), copy.freeProgressAfter);
        }

        function applyCartState(cart, version) {
          if (!isCartPayload(cart)) return false;
          if (version < appliedVersion) return false;
          appliedVersion = version;
          lastKnownCart = cart;

          ensureDrawerBar(cart);
          const bars = getBars();
          if (!bars.length) return true;

          bars.forEach(function (bar) {
            updateBar(bar, cart);
          });

          return true;
        }

        function enforceBarsFromLastCart() {
          if (!lastKnownCart) return false;
          return applyCartState(lastKnownCart, appliedVersion);
        }

        function clearFollowUpRefreshes() {
          followUpRefreshTimerIds.forEach(function (timerId) {
            window.clearTimeout(timerId);
          });
          followUpRefreshTimerIds = [];
        }

        function queueFollowUpRefreshes() {
          clearFollowUpRefreshes();
          // Re-apply after drawer morphs from the cached cart; only one follow-up goes to the network.
          [240, 900, 3600].forEach(function (delay) {
            followUpRefreshTimerIds.push(window.setTimeout(function () {
              if (!enforceBarsFromLastCart()) scheduleRefresh();
            }, delay));
          });
          followUpRefreshTimerIds.push(window.setTimeout(function () {
            scheduleRefresh();
          }, 1800));
        }

        async function refreshBars(cartOverride) {
          if (!hasShippingBarContext()) return;

          const cartPayload = isCartPayload(cartOverride) ? cartOverride : null;
          if (cartPayload) {
            return applyCartState(cartPayload, nextRefreshVersion());
          }

          if (refreshInFlight) return refreshInFlight;

          const requestVersion = nextRefreshVersion();
          refreshInFlight = (async function () {
            try {
              const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
                return response.json();
              });

              if (requestVersion !== refreshVersion) return;
              applyCartState(cart, requestVersion);
            } catch (error) {}
            finally {
              if (requestVersion === refreshVersion) {
                refreshInFlight = null;
              } else {
                refreshInFlight = null;
              }
            }
          })();

          return refreshInFlight;
        }

        function scheduleRefresh(cartOverride) {
          if (!hasShippingBarContext()) return;
          const cartPayload = isCartPayload(cartOverride) ? cartOverride : null;

          if (cartPayload) {
            scheduledCart = cartPayload;
            applyCartState(cartPayload, nextRefreshVersion());
          }

          if (refreshScheduled) return;
          refreshScheduled = true;

          window.setTimeout(function () {
            const cartToApply = scheduledCart;
            scheduledCart = null;
            const refreshPromise = refreshBars(cartToApply);
            if (!refreshPromise || typeof refreshPromise.finally !== 'function') {
              refreshScheduled = false;
              return;
            }
            refreshPromise.finally(function () {
              refreshScheduled = false;
            });
          }, cartPayload ? 90 : 140);
        }

        function handleCartUpdate(event) {
          const cartPayload = extractCartFromEvent(event);
          scheduleRefresh(cartPayload);
          queueFollowUpRefreshes();
        }

        function shouldCorrectBarMutation(target) {
          if (!(target instanceof HTMLElement)) return false;
          const bar = target.closest?.(barSelector);
          if (!(bar instanceof HTMLElement)) return false;

          const text = bar.textContent || '';
          if (
            text.includes('Congratulations') ||
            text.includes("You've unlocked free shipping") ||
            text.includes('Excellent choice')
          ) {
            return true;
          }

          if (!lastKnownCart) return false;
          const fill = bar.querySelector('[data-bw-shipping-fill]');
          if (!(fill instanceof HTMLElement)) return true;

          const expectedStage = getProgressState(lastKnownCart, bar).giftUnlocked
            ? 'gift'
            : getProgressState(lastKnownCart, bar).freeUnlocked
              ? 'free-shipping'
              : 'locked';
          return bar.dataset.bwRewardStage !== expectedStage;
        }

        function startObserver() {
          if (observerStarted || !(document.body instanceof HTMLElement)) return;
          observerStarted = true;

          let correctionQueued = false;
          const observer = new MutationObserver(function (mutations) {
            const shouldRefresh = mutations.some(function (mutation) {
              const target = mutation.target instanceof HTMLElement ? mutation.target : mutation.target?.parentElement;
              if (shouldCorrectBarMutation(target)) {
                if (!correctionQueued) {
                  correctionQueued = true;
                  window.requestAnimationFrame(function () {
                    correctionQueued = false;
                    enforceBarsFromLastCart();
                  });
                }
                return false;
              }

              return Array.from(mutation.addedNodes).some(function (node) {
                return (
                  node instanceof HTMLElement
                  && (
                    node.matches(barSelector)
                    || node.matches(drawerContentSelector)
                    || node.querySelector(barSelector)
                    || node.querySelector(drawerContentSelector)
                  )
                );
              });
            });

            if (shouldRefresh) scheduleRefresh();
          });

          observer.observe(document.body, { childList: true, subtree: true, attributes: true, characterData: true });
        }

        const api = {
          refresh: function () {
            return refreshBars();
          },
          schedule: function (cart) {
            return scheduleRefresh(cart);
          },
          apply: function (cart) {
            if (!isCartPayload(cart)) return false;
            return applyCartState(cart, nextRefreshVersion());
          },
        };

        window.BWShippingBar = api;
        window.BW_ShippingBar = api;

        document.addEventListener('cart:update', handleCartUpdate);
        document.addEventListener('cart:error', function () {
          scheduleRefresh();
          queueFollowUpRefreshes();
        });
        window.addEventListener('pageshow', function () {
          scheduleRefresh();
        });

        function startWhenPageSettles() {
          const start = function () {
            startObserver();
            scheduleRefresh();
          };

          if (hasShippingBarContext()) {
            start();
            return;
          }

          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(start, { timeout: 2600 });
          } else {
            window.setTimeout(start, 1400);
          }
        }

        if (document.readyState === 'loading') {
          document.addEventListener(
            'DOMContentLoaded',
            startWhenPageSettles,
            { once: true }
          );
        } else {
          startWhenPageSettles();
        }
      })();
